import { gql } from '@apollo/client';

const PopularSearchesQuery = gql`
  query PopularSearchesQuery($params: JSONObject) {
    searchSeoHome(params: $params)
  }
`;

export default PopularSearchesQuery;
